import {
  GET_LEAD_INDICATORS,
  GET_LEAD_INDICATORS_FAIL,
  SET_QUESTIONS_AND_SCORING_DATA,
} from "../constant";

const initialState = {
  leadIndicators: {},
  leadsList: [],
  scoringLogic: {},
  totalQuestions: 0,
  totalSections: 0,
  questions: [],
};

const leadIndicatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD_INDICATORS:
      return {
        ...state,
        leadIndicators: action.payload.leadIndicators,
        leadsList: action.payload.leadsList,
      };
    case GET_LEAD_INDICATORS_FAIL:
      return {
        ...state,
        leadIndicator: [],
        leadsList: [],
      };
    case SET_QUESTIONS_AND_SCORING_DATA:
      return {
        ...state,
        scoringLogic: action.payload.scoringLogic,
        totalQuestions: action.payload.totalQuestions,
        totalSections: action.payload.totalSections,
        questions: action.payload.questions,
        leadsList: action.payload.leadsList,
      };
    default:
      return state;
  }
};

export { leadIndicatorReducer };
